import Swal from "sweetalert2";

export const handlePaymentStatusUpdateNew = async (
  rentalId,
  paymentStatus,
  {
    setUpdatingPaymentId,
    rentals,
    fetchData,
    setIsLoading,
    setError,
  }
) => {
  try {    setUpdatingPaymentId(rentalId);
    await rentals.updatePaymentStatusNew(rentalId, paymentStatus);
    fetchData();
    
    const statusText = paymentStatus.charAt(0).toUpperCase() + paymentStatus.slice(1);
    await Swal.fire({
      icon: "success",
      title: "Success",
      text: `Payment status updated to ${statusText}`,
      confirmButtonColor: "#1e3a8a",
    });
  } catch (error) {
    console.error("Error updating payment status:", error);
    await Swal.fire({
      icon: "error",
      title: "Error",
      text: "Failed to update payment status. Please try again.",
      confirmButtonColor: "#1e3a8a",
    });
  } finally {
    setUpdatingPaymentId(null);
  }
};
